(() => {
  function filterItems(root, categoryId) {
    const items = root.querySelectorAll('.media-list__item');

    items.forEach((item) => {
      const itemCategory = item.dataset.category || '';
      const show = categoryId === 'all' || itemCategory === categoryId;
      item.classList.toggle('is-hidden', !show);
      item.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
  }

  function switchTab(root, tab) {
    const tabs = root.querySelectorAll('.media-list__tab');
    const categoryId = tab.dataset.category || 'all';

    tabs.forEach((item) => {
      const isActive = item === tab;
      item.classList.toggle('active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    filterItems(root, categoryId);
  }

  function initTabs(root) {
    const tabs = root.querySelectorAll('.media-list__tab');
    if (tabs.length === 0) return;

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => switchTab(root, tab));

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + tabs.length) % tabs.length;
        const nextTab = tabs[nextIndex];
        nextTab.focus();
        switchTab(root, nextTab);
      });
    });

    const activeTab = root.querySelector('.media-list__tab.active') || tabs[0];
    switchTab(root, activeTab);
  }

  function init(root) {
    if (!root || root.dataset.mediaListInit === 'true') return;

    root.classList.add('media-list--initialized');
    initTabs(root);
    root.dataset.mediaListInit = 'true';
  }

  function initAll() {
    document.querySelectorAll('.media-list').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.media-list');
    if (root) {
      delete root.dataset.mediaListInit;
      init(root);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('.media-list');
    if (root) {
      delete root.dataset.mediaListInit;
    }
  });
})();
